import { getAxisEncodingKeysForType, getChartFamilyForType } from './chart-type';
import { resolveMeasureNameHandling } from './family';
import { configReferencesMeasureNames, getUniqueColumnsFromConfigs, } from './helpers';
import { buildLineStackedColumnExtras } from './line-stacked-column';
import { addMeasureNameField, addMeasureValueField } from './measure-name-value';
import { getTotalsQueries, reconcileTotalsFlags } from './totals';
import { ChartFamily, DataQueryBucketKey, DATA_SIZE_LIMIT, NO_TOTALS, } from './types';
function buildAllColsQuery(chartConfigs, params) {
    return {
        queryColumns: getUniqueColumnsFromConfigs(chartConfigs).slice(),
        queryParams: {
            size: params?.size || DATA_SIZE_LIMIT,
            offset: params?.offset || 0,
        },
    };
}
function applyMnAndMv(queries, chartModel) {
    const withMn = addMeasureNameField(queries, chartModel);
    return addMeasureValueField(withMn, chartModel);
}
export function buildQueriesFromChartConfig(chartType, chartModel, chartConfig, queryParams, axisEncodings, totalsEnabledFlags = NO_TOTALS) {
    const family = getChartFamilyForType(chartType);
    const configHasMN = configReferencesMeasureNames(chartConfig);
    const { forceMeasureNames, includeMnMvInRootQuery } = resolveMeasureNameHandling(family, configHasMN);
    const reconciledTotalsFlags = reconcileTotalsFlags(totalsEnabledFlags, chartConfig, chartType);
    const { queries: rawTotalsQueries, queryIndexTypeMap } = getTotalsQueries({
        chartModel,
        chartConfig,
        axisEncodings: axisEncodings ?? getAxisEncodingKeysForType(chartType),
        totalsEnabledFlags: reconciledTotalsFlags,
        queryParams,
    });
    const rawRootQuery = buildAllColsQuery(chartConfig, queryParams);
    let totalsQueries = rawTotalsQueries;
    if (forceMeasureNames) {
        totalsQueries = applyMnAndMv(totalsQueries, chartModel);
    }
    let rootQueries = [rawRootQuery];
    if (includeMnMvInRootQuery) {
        rootQueries = applyMnAndMv(rootQueries, chartModel);
    }
    queryIndexTypeMap[DataQueryBucketKey.Root] = [totalsQueries.length];
    if (family !== ChartFamily.LineStackedColumn) {
        return {
            queries: [...totalsQueries, ...rootQueries],
            queryIndexTypeMap,
        };
    }
    const rowGrandIdx = queryIndexTypeMap[DataQueryBucketKey.RowGrandTotals] ?? [];
    const rowSubIdx = queryIndexTypeMap[DataQueryBucketKey.RowSubTotals] ?? [];
    const extras = buildLineStackedColumnExtras(rowGrandIdx.map((i) => totalsQueries[i]), rowSubIdx.map((i) => totalsQueries[i]), chartConfig, chartModel, queryParams);
    const lineQueries = [];
    const baseIndex = totalsQueries.length + rootQueries.length;
    if (extras.lineRoot) {
        queryIndexTypeMap[DataQueryBucketKey.LineRoot] = [baseIndex];
        lineQueries.push(extras.lineRoot);
    }
    if (extras.lineRowGrandTotals.length) {
        const start = baseIndex + lineQueries.length;
        queryIndexTypeMap[DataQueryBucketKey.LineRowGrandTotals] = extras.lineRowGrandTotals.map((_, i) => start + i);
        lineQueries.push(...extras.lineRowGrandTotals);
    }
    if (extras.lineRowSubTotals.length) {
        const start = baseIndex + lineQueries.length;
        queryIndexTypeMap[DataQueryBucketKey.LineRowSubTotals] = extras.lineRowSubTotals.map((_, i) => start + i);
        lineQueries.push(...extras.lineRowSubTotals);
    }
    return {
        queries: [...totalsQueries, ...rootQueries, ...lineQueries],
        queryIndexTypeMap,
    };
}
//# sourceMappingURL=all-cols.js.map